import React from 'react'

export default function Copyright(){
   return (
     <div id="copyright" className="copyright">Designed & Build by Boris Polderman - 2023 ©</div>
  );
}
